import { cn } from "utils";
import { Text } from "components/text";

interface EmptyPanelProps {
  image: React.ReactNode;
  title: string;
  text?: React.ReactNode;
  errorMessage?: string;
  buttons?: React.ReactNode[];
  orientation?: "vertical" | "horizontal";
  hideOnShortScreen?: boolean;
  classes?: {
    container?: string;
    title?: string;
    text?: string;
  };
}

export const EmptyPanel = ({
  image,
  title,
  text,
  errorMessage,
  buttons,
  orientation = "vertical",
  hideOnShortScreen = false,
  classes,
}: EmptyPanelProps) => {
  const leftAligned = "items-start justify-start text-left";
  const centerAligned = "items-center justify-center text-center";
  const aligned = orientation === "horizontal" ? leftAligned : centerAligned;
  const titleStyle = orientation === "horizontal" ? "font-semibold" : undefined;
  const textStyle =
    orientation === "horizontal" ? "text-secondary-400" : undefined;
  const flexDirection = orientation === "horizontal" ? "flex-row" : "flex-col";
  const hideOnShortScreenStyle = hideOnShortScreen
    ? "hide-on-short-screen"
    : undefined;

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-5 py-8",
        flexDirection,
        classes?.container,
      )}
    >
      <div className={hideOnShortScreenStyle} data-testid="empty-panel-image">
        {image}
      </div>
      <div className={cn("flex flex-col justify-center gap-5", aligned)}>
        <div className={cn("text-center space-y-2 px-4 text-balance", aligned)}>
          <Text variant="title" className={cn(titleStyle, classes?.title)}>
            {title}
          </Text>
          {text && (
            <Text
              as="div"
              variant="muted"
              className={cn(textStyle, "text-pretty", classes?.text)}
            >
              {text}
            </Text>
          )}
          {errorMessage && <Text variant="error">{errorMessage}</Text>}
        </div>
        {buttons && (
          <div className={cn("flex gap-2 px-4", aligned)}>{buttons}</div>
        )}
      </div>
    </div>
  );
};
